<!-- Page content -->
<div id="main">
    <router-outlet (activate)="onRouteActivated($event)"></router-outlet>
</div>